<template>
  <el-header>
        <div class="headtop">
            <div class="headleft">
                <!-- <div class="logo">
                    <img src="../assets/images/logo_white.webp" style="width:100%;height:100%">
                </div> -->
                <div class="title">
                    <p>起重机械生产企业安全智能综合监管平台</p>
                    <p>Construction Machinery Enterprise Intelligent Comprehensive Supervision Platform</p>
                </div>
            </div>
            <div class="headright">
                <!-- <span class="el-icon-bell" style="color:white;font-size:23px;cursor: pointer;" >
                    <el-badge is-dot style="top:-10px;right:7px"></el-badge>
                </span> -->
                <img :src="imgSrc" @click="buttoncli" style="width: 23px; height: 23px;">
                <span class="el-icon-user" style="color:white;font-size:23px;cursor: pointer;"></span>
                <div>
                    <el-dropdown @command="avatarDown">
                        <span class="el-dropdown-link" style="color:#fff;cursor: pointer">
                            欢迎您! {{user.name}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="BigScreen" v-if="user.systemRole !=6 && user.systemRole !=0"><i class="el-icon-monitor" style="fontSize:17px"></i>大屏展示</el-dropdown-item>
                            <el-dropdown-item command="editPass"><i class="el-icon-lock" style="fontSize:17px"></i>修改密码</el-dropdown-item>
                            <el-dropdown-item command="showPass"><i class="el-icon-view" style="fontSize:17px"></i>查看密码</el-dropdown-item>
                            <el-dropdown-item command="loginOut"><i class="el-icon-switch-button" style="color:red;fontSize:18px"></i>退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>

        <el-dialog title="查看" :visible.sync="showPass" width="300px" >
            <div class="lookPass">当前用户密码:&nbsp;&nbsp;{{ pwd }}</div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="showPass = false" size="mini">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="修改密码" :visible.sync="editPass" width="30%" top="25vh" :close-on-click-modal="false"> 
            <el-form :model="passUpdate" :rules="password" label-position="left" ref="password">
                <el-form-item label="原密码" label-width="100px" prop="oldPwd">
                    <el-input v-model="passUpdate.oldPwd" type="password" autocomplete="off" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="新密码" label-width="100px" prop="newPwd">
                    <el-input v-model="passUpdate.newPwd" type="password" autocomplete="off" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" label-width="100px" prop="againPwd">
                    <el-input v-model="passUpdate.againPwd" type="password" autocomplete="off" size="mini"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editPass = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="confirmOprate" size="mini">确 定</el-button>
            </div>
        </el-dialog>

        <div class="headbottom" v-if="false">
            <div class="headers-left-box" :class="this.flag === false ? 'headers-left-active' : ''" @click="$emit('checkaside')">
                <i class="el-icon-s-fold " style="font-size:25px"></i>
            </div>
            <el-breadcrumb separator-class="el-icon-arrow-right" separator="/" class="app-breadcrumb" >
                <transition-group name="breadcrumb"  mode="out-in">
                    <el-breadcrumb-item v-for="(item,index) in $route.matched" :key="item.path" >
                        <span v-if='item.redirect==="guide1"||index==$route.matched.length-1' class="no-redirect">{{item.meta.title}}</span>
                        <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>
                    </el-breadcrumb-item>
                </transition-group>
            </el-breadcrumb>
            <el-tag
                v-for="(tag,i) in tagList"
                :key="i"
                closable
                size="small"
                effect="dark"
                :disable-transitions="false"
                :type="tag.title == $route.meta.title?'success':'info'"
                ref="tag"
                @close.stop="tagClose(tag)"
                @click="checkTag(tag)"
                @contextmenu.prevent.native="tagDown(tag,$event)"
            >
                {{tag.title}}
            </el-tag>
            <ul class='contextmenu' v-show="contextmenuShow" :style="{left:mouseLeft+'px',top:mouseTop+'px'}">
                <li @click="tagClose(selectedTag)">关闭</li>
                <li @click="closeOthersTags">关闭其它</li>
                <li @click="closeAllTags">关闭所有</li>
            </ul>
        </div>
    </el-header>
</template>

<script>
export default {
    props:['flag'],
    data(){
        const pwdCheck = async (rule, value, callback) => {
            if (value === '') {
                callback(new Error('密码不能为空！'));
                return false;
            }
            if (value.length < 8) {
                callback(new Error('密码长度不足8位！'));
                return false;
            }
            var reg1 = /(?=.*[a-z].*)(?=.*[A-Z].*)(.*[0-9].*)/;
            if (!reg1.test(value)) {
                callback(new Error('密码必须包含大小字母和数字！'));
                return false;
            }
            callback();
            return true;
        };
        const pwdAgainCheck = async (rule, value, callback) => {
            if (value === '') {
                callback(new Error('确认密码不能为空！'));
                return false;
            } else if (this.passUpdate.newPwd != value) {
                callback(new Error('两次输入密码不一致！'));
                return false;
            } else {
                callback();
                return true;
            }
        };
        return{
            user:{},
            //tag标签列表
            tagList: [],
            //tag标签的下拉控制
            contextmenuShow:false,
            mouseLeft:0,
            mouseTop:0,
            //当前选择的tag标签
            selectedTag:{},
            //查看密码dialog
            showPass:false,
            //修改密码dialog
            editPass:false,
            //修改密码的表单信息
            passUpdate: {
                oldPwd: "",
                newPwd: "",
                againPwd: "",
            },
            pwd:'',
            //修改密码的表单检验规则
            password: {
                oldPwd: [{
                    required: true,
                    message: "请填写原密码",
                    trigger: "blur"
                }],
                newPwd: [{
                    required: true,
                    validator: pwdCheck,
                    trigger: "blur"
                }],
                againPwd: [{
                    required: true,
                    validator: pwdAgainCheck,
                    trigger: "blur"
                }],
            },
            isFullscreen: false,
            imgSrc: require('../assets/images/quanping.webp')
        }
    },
    created(){
        this.tagList[0] = {title:this.$route.meta.title,path:this.$route.path};
        
    },
    mounted(){
        this.user = JSON.parse(localStorage.getItem('user'))
    },
    methods:{
        //头像下拉菜单
        avatarDown(command){
            if(command == 'BigScreen'){
                this.$router.push('/BigScreen')
            }else if(command == 'editPass'){
                this.editPass = true
            }else if(command == 'showPass'){
                this.$api.GetSlefPassword().then(res=>{
                   this.pwd = res.data.data
                })
                this.showPass = true
            }else{
                //退出登录
                localStorage.clear();
                this.$router.push('/Login')
            }
        },
        //添加tag
        tagAdd(){
            this.tagList.push({
                title:this.$route.meta.title,
                path:this.$route.path
            });
            this.tagList.forEach((item1,i1)=>{
                this.tagList.map((item2,i2)=>{
                    if(i1 == i2) return;
                    if(item1.title == item2.title) { this.tagList.splice(i2,1) };
                })
            })
        },
        //关闭tag
        tagClose(tag){
            this.tagList.splice(this.tagList.indexOf(tag), 1);
            if(tag.title != this.$route.meta.title) return
            this.tagList.length > 0 && this.$router.push(this.tagList[this.tagList.length-1].path)
        },
        //tag下拉菜单
        tagDown(tag,e){
            this.contextmenuShow = true;
            this.selectedTag = tag;
            this.mouseLeft = e.clientX;
            this.mouseTop = e.clientY;
        },
        //tag下拉菜单关闭
        tagDownClose(value){
            if (value) {
                document.body.addEventListener('click', ()=>{this.contextmenuShow = false})
            } else {
                document.body.removeEventListener('click', ()=>{this.contextmenuShow = false})
            }
        },
        //关闭其他tag
        closeOthersTags(){
            if(this.tagList.length == 1) return;
            this.tagList = [this.selectedTag];
            if(this.selectedTag.path == this.$route.path) return;
            this.$router.push(this.selectedTag.path)
        },
        //关闭所有tag
        closeAllTags(){
            this.tagList = []
        },
        //切换tag
        checkTag(tag){
            if (tag.title == this.$route.meta.title) return
            this.$router.push(tag.path)
        },
        //确认修改密码
        confirmOprate() {
            this.$refs["password"].validate(valid => {
                if (valid) {
                    this.$api.ChangePassword({oldPassword:this.passUpdate.oldPwd,newPassword:this.passUpdate.newPwd}).then(res=>{
                        if(res.data.code == 200){
                            this.$notify({
                                title:'',
                                message: '修改成功！',
                                type: 'success'
                            })
                            this.editPass = false
                            return;
                        }else{
                            this.$notify({
                                title:'',
                                message: res.data.msg || '修改失败！',
                                type: 'error'
                            })
                            return;
                        }
                    })
                }
            });
        },
        // 全屏
        buttoncli(){
                this.$screenfull.toggle()
                this.checkFull()
        },
        // 监控屏幕变化
        checkFull() {
            var isFull = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled;
            // to fix : false || undefined == undefined
            // 是否全屏判断
            this.isFullscreen = !this.isFullscreen;
            if(this.isFullscreen){
                this.imgSrc = require('../assets/images/suoxiao.webp')
            }else{
                this.imgSrc = require('../assets/images/quanping.webp')
            }
            if (isFull === undefined) {
                isFull = false;
            }
            return isFull;
        },
    },
    watch:{
        //监听路由变化动态添加tag标签
        $route(){
            this.tagAdd()
        },
        //动态为tag标签添加和移除右键事件
        contextmenuShow(value) {
            this.tagDownClose(value)
        }
    },
}
</script>

<style lang="scss" scoped>
.el-header {
    background-color: rgb(238, 241, 246);
    color: #333;
    height: 65px !important;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
    border-bottom: 1px solid #eee;
}
.headtop,.headbottom{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px;
    background-color: #407BDB;
}
.headbottom{
    background: #fff;
    height: 40%;
    justify-content: flex-start;
    padding-left: 10px;
}
.headleft{
    align-items: center;
    display: flex;
    height: 80%;
    justify-content: space-around;
}
.logo{
    width: 45px;
    height: 45px;
    margin-left: 10px;
}
.title{
    height: 100%;
    color: #fff;
    margin-left: 15px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    & p:nth-child(1){
        letter-spacing: 3px;
        font-weight: bold;
        font-size: 19px;
    }
    & p:nth-child(2){
        font-size: 12px;
        
    }
}
.headers-left-box{
    cursor: pointer;
    transition: all 0.7s;
    transform-origin: center center;
    margin-left: 10px;
}
.headers-left-active{
    transform: rotate(180deg);
}
.headright{
    width: 170px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 5px;
    img{
        cursor: pointer;
    }
}
.el-button{
    width: 70px;
}
.el-tag{
    margin: 0 5px;
    cursor: pointer;
    position: relative;
}
.el-tag-active{
    color: #fff;
    background-color: #409EFF;
    border-color: #409EFF;
}
.contextmenu {
    margin: 0;
    background: #fff;
    z-index: 2;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
.app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
}
.no-redirect {
    color: #97a8be;
    cursor: text;
} 
.breadcrumb-enter-active,
.breadcrumb-leave-active{
    transition: all 0.5s;
}
    .breadcrumb-enter,.breadcrumb-leave-to{
    opacity: 0;
    transform: translateX(20px);
}
.breadcrumb-enter-to,.breadcrumb-leave{
    opacity: 1;
    transform: translateX(0px);
} 
.breadcrumb-enter,
.breadcrumb-leave-active{
    opacity: 0;
    transform: translateX(20px);
}
.breadcrumb-move{
    transition: all 0.5s;
}
.breadcrumb-leave-active{
    position: absolute;;
}
</style>